import React, { useContext } from "react";
import { AuthContext } from "../AuthContext";

const Sidebar = ({ activePage, setActivePage }) => {
    const { roles } = useContext(AuthContext);

    const navItems = [
        { id: "dashboard", label: "Dashboard", icon: "📊", allowedRoles: ["SuperAdmin", "Admin", "Automation_Tester", "Team_Lead"] },
        { id: "gameExecution", label: "Game Executions", icon: "🎮", allowedRoles: ["Tester","Automation_Tester","Team_Lead","Admin","SuperAdmin","App_Support","Product_Team"] },
        { id: "automationManagement", label: "Automation Results", icon: "🤖", allowedRoles: ["Automation_Tester","Team_Lead","Admin","SuperAdmin"] },
        { id: "TestcaseManagement", label: "Testcase Repository", icon: "🧪", allowedRoles: ["Automation_Tester","Tester","Team_Lead","Admin","SuperAdmin"] },
        { id: "ExecuteTestcaseModal", label: "Manual Execution", icon: "🚀", allowedRoles: ["Automation_Tester","Tester","Team_Lead","Admin","SuperAdmin"] },
        { id: "ExecutedTestcases", label: "Execution History", icon: "📋", allowedRoles: ["Team_Lead","Admin","SuperAdmin"] },
        { id: "seoResults", label: "SEO Results", icon: "🔍", allowedRoles: ["SuperAdmin", "Admin", "Automation_Tester", "Team_Lead", "Tester"] },
        { id: "seoReports", label: "SEO Reports", icon: "📈", allowedRoles: ["SuperAdmin", "Admin", "Automation_Tester", "Team_Lead", "Tester"] },
        { id: "userRestrictions", label: "User Restrictions", icon: "🔒", allowedRoles: ["SuperAdmin"] },
    ];

    const canAccess = (allowedRoles = []) => roles.some((r) => allowedRoles.includes(r));

    return (
        <aside className="fixed top-16 bottom-0 left-0 w-64 bg-gray-900 text-white border-r border-gray-800 shadow-inner z-30">
            <nav className="px-6 pt-6">
                <ul className="space-y-2">
                    {navItems.map((item) => {
                        if (!canAccess(item.allowedRoles)) return null;
                        const isActive = activePage === item.id;
                        return (
                            <li key={item.id}>
                                <button
                                    onClick={() => setActivePage(item.id)}
                                    className={`
                    w-full flex items-center gap-3 px-4 py-2 rounded-md text-sm font-medium transition-all
                    ${isActive
                                        ? "bg-gradient-to-r from-purple-500 to-purple-600 text-white"
                                        : "text-gray-400 hover:bg-gray-800 hover:text-white"
                                    }
                  `}
                                >
                                    <span className="text-lg">{item.icon}</span>
                                    <span className="truncate">{item.label}</span>
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </aside>
    );
};

export default Sidebar;
